import React, { useCallback, useMemo } from 'react';
import { Slide, Snackbar, SnackbarContent } from '@material-ui/core';
import PropTypes from 'prop-types';
import SlideUp from '~/modules/common/components/SlideUp';
import { useMeContext } from '~/modules/me/useMeContext';
import { RESOURCE_USER_DETAILS_ACTION } from '~/modules/resource-management/resourceUserDetails/hooks/resourceUserDetailsAction';
import { useSnackbarStyles } from './useStyles';
import { useResourceUserDetailsContext } from './ResourceUserDetailsContext';

const SNACKBAR_POSITION = {
  BOTTOM_LEFT: { vertical: 'bottom', horizontal: 'left' },
  TOP_CENTER: { vertical: 'top', horizontal: 'center' }
};

const ResourceUserSnackbar = ({ open, message, snackBarPosition }) => {
  const {
    featureFlags: { isPsaPraaUserProfileNudgesEnabled }
  } = useMeContext();

  const classes = useSnackbarStyles();
  const {
    state: { snackbarMessage },
    dispatch
  } = useResourceUserDetailsContext();

  const hideMessage = useCallback(() => {
    dispatch({
      type: RESOURCE_USER_DETAILS_ACTION.SET_SNACKBAR_MESSAGE,
      snackbarMessage: null
    });
  }, [dispatch]);

  const defaultSnackBarPosition = useMemo(
    () =>
      isPsaPraaUserProfileNudgesEnabled
        ? SNACKBAR_POSITION.BOTTOM_LEFT
        : SNACKBAR_POSITION.TOP_CENTER,
    [isPsaPraaUserProfileNudgesEnabled]
  );

  return isPsaPraaUserProfileNudgesEnabled ? (
    <Snackbar
      open={Boolean(snackbarMessage)}
      onClose={hideMessage}
      autoHideDuration={5000}
      anchorOrigin={defaultSnackBarPosition}
      TransitionComponent={SlideUp}
      message={snackbarMessage}
    />
  ) : (
    <Snackbar
      anchorOrigin={snackBarPosition || defaultSnackBarPosition}
      open={open}
      TransitionComponent={Slide}
    >
      <SnackbarContent classes={classes} message={message} />
    </Snackbar>
  );
};

ResourceUserSnackbar.propTypes = {
  open: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  snackBarPosition: PropTypes.shape({
    vertical: PropTypes.string,
    horizontal: PropTypes.string
  })
};

export default ResourceUserSnackbar;
